import React from "react";
// import logo from "./logo.svg";
import "./App.css";
import { SearchBar } from "./components/SearchBar";
import { SearchResults } from "./components/SearchResults";
import { Pagination } from "./components/Pagination";
import { FilterList } from "./components/FilterList";
import { FilterCluster } from "./components/filters/FilterCluster";
import { FilterCheckbox } from "./components/filters/FilterCheckbox";

function App() {
  const [searchText, setSearchText] = React.useState("");
  // eslint-disable-next-line
  const [selectedRecord, setSelectedRecord] = React.useState({});
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(1);
  const [filterState, setFilterState] = React.useState({});

  return (
    <div className="App">
      {/* <div className="searchContent"> */}
      <div className="searchBarContainer">
        <SearchBar searchFunction={setSearchText} />
      </div>
      <div className="main">
        <div className="sidebar leftSidebar">
          <FilterCheckbox
            filterState={filterState}
            setFilterState={setFilterState}
            filterName="Search in name"
            stateKey="searchIn_name"
          />
          <FilterCheckbox
            filterState={filterState}
            setFilterState={setFilterState}
            filterName="Search in author"
            stateKey="searchIn_author"
          />
          <FilterCheckbox
            filterState={filterState}
            setFilterState={setFilterState}
            filterName="Search in path"
            stateKey="searchIn_path"
          />
          <FilterCheckbox
            filterState={filterState}
            setFilterState={setFilterState}
            filterName="Search in tags"
            stateKey="searchIn_tags"
          />
        </div>
        <div className="content">
          <div className="contentHeader">
            <div className="contentDisplayOptions">Content display options</div>
            <div className="contentBreadcrumbs">Breadcrumbs</div>
          </div>
          <div className="contentMain">
            <SearchResults
              searchText={searchText}
              currentPage={currentPage}
              filters={filterState}
              setCurrentPage={setCurrentPage}
              setTotalPages={setTotalPages}
              setSelectedRecord={setSelectedRecord}
            />
          </div>
          <div className="paginationContainer">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              setPage={setCurrentPage}
            />
          </div>
          {false && <div className="contentSecondary">Secondary content</div>}
        </div>
        <div className="sidebar rightSidebar">
          <div className="sidebarItem sidebarItemName">Item Name</div>
          <div className="sidebarItem sidebarItemThumbnail">Item Thumbnail</div>
          <div className="sidebarItem sidebarItemInfo">Item Info</div>
        </div>
      </div>
      {/* </div> */}
    </div>
  );
}

export default App;
